import { set, has } from 'lodash'
import Vue from 'vue'
import { REQUEST_STATE } from './constants'

export const getMutations = types =>
  Object.values(types).reduce((mutations, type) => {
    if (!has(type, 'BASE')) {
      return mutations
    }

    mutations[type.urlKey] = (state, url) => {
      set(state, type.urlKey, url)
    }

    mutations[type.BASE] = (state, payload) => {
      // console.log(payload)
      switch (payload.type) {
        case REQUEST_STATE.STATE_PENDING: {
          // if (state[MUTATION_TYPES.SEARCH.cancelSource]) {
          //   state[MUTATION_TYPES.SEARCH.cancelSource].cancel()
          // }
          Vue.set(state, type.promiseKey, payload.promise)
          set(state, type.stateKey, payload.type)
          if (has(payload, 'data')) {
            set(state, type.dataKey, payload.data)
          }
          if (has(payload, 'cancelSource')) {
            Vue.set(state, type.cancelSource, payload.cancelSource)
          }
          return
        }
        case REQUEST_STATE.STATE_SUCCESS:
          Vue.set(state, type.dataKey, payload.data)
          set(state, type.stateKey, payload.type)
          set(state, type.statusCodeKey, payload.status)
          set(state, type.errorMessageKey, null)
          set(state, type.requestCount, state[type.requestCount] + 1)
          Vue.set(state, type.cancelSource, null)
          return
        case REQUEST_STATE.STATE_FAILURE:
          Vue.set(state, type.errorMessageKey, payload.errorMessage)
          set(state, type.stateKey, payload.type)
          set(state, type.statusCodeKey, payload.status)
          // set(state, type.dataKey, payload.data)
          set(state, type.requestCount, state[type.requestCount] + 1)
          Vue.set(state, type.cancelSource, null)
          return
        case REQUEST_STATE.STATE_INITIAL:
          Vue.set(state, type.errorMessageKey, null)
          set(state, type.stateKey, payload.type)
          set(state, type.statusCodeKey, null)
          set(state, type.dataKey, null)
          Vue.set(state, type.cancelSource, null)
      }
    }
    return mutations
  }, {})

export const getState = types =>
  Object.values(types).reduce((state, type) => {
    if (!has(type, 'BASE')) {
      return state
    }

    return {
      ...state,
      [type.urlKey]: null,
      [type.stateKey]: REQUEST_STATE.STATE_INITIAL,
      [type.promiseKey]: null,
      [type.cancelSource]: null,
      [type.statusCodeKey]: null,
      [type.errorMessageKey]: null,
      [type.dataKey]: null,
      [type.requestCount]: 0,
    }
  }, {})

export const getStateGetters = types =>
  Object.values(types).reduce(
    (getters, type) => ({
      ...getters,
      ...Object.keys(REQUEST_STATE).reduce((stateGetters, requestState) => {
        if (!has(type, 'BASE')) {
          return stateGetters
        }
        return {
          ...stateGetters,
          [`${type.BASE}_${requestState}`]: state => state[type.stateKey] === requestState,
        }
      }, {}),
    }),
    {},
  )
